module.exports = __webpack_public_path__ + "fonts/049db6a567fff4f91dbfce4fe05bf907.svg";